export default function PageTitle() {
  return (
    <div className="pageTitle">
      <span className="qleft">
        <span className="q1">
          <h1>?</h1>
        </span>
        <span className="q2">
          <h1>?</h1>
        </span>
        <span className="q3">
          <h1>?</h1>
        </span>
        <span className="q4">
          <h1>?</h1>
        </span>
        <span className="q5">
          <h1>?</h1>
        </span>
      </span>
      <h1>What is the Weather</h1>
      <span className="qright">
        <span className="q5">
          <h1>?</h1>
        </span>
        <span className="q4">
          <h1>?</h1>
        </span>
        <span className="q3">
          <h1>?</h1>
        </span>
        <span className="q2">
          <h1>?</h1>
        </span>
        <span className="q1">
          <h1>?</h1>
        </span>
      </span>
    </div>
  );
}
